import React from 'react';
import { practiceDisplayName } from '../lib/practiceAccess';

// The practice name is marked data-phi: with "Hide PHI" on (see
// lib/phiPrivacy.js) it is blurred too, since it identifies the customer
// on a shared screen.
const PracticePicker = ({ practices, value, onChange }) => {
  if (!practices || practices.length === 0) {
    return (
      <p data-phi style={{ margin: '0 0 8px 0', fontSize: '0.9rem', color: '#6b716d' }}>
        Practice: {value || '—'}
      </p>
    );
  }

  const current = practices.find((p) => p.practiceId === value) || practices[0];

  if (practices.length === 1) {
    return (
      <p data-phi style={{ margin: '0 0 8px 0', fontSize: '0.9rem', color: '#6b716d' }}>
        {practiceDisplayName(current)}
      </p>
    );
  }

  return (
    <label style={{ display: 'block', margin: '0 0 8px 0' }}>
      <span
        style={{
          display: 'block',
          fontSize: '0.75rem',
          fontWeight: 600,
          color: '#6b716d',
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          marginBottom: '6px',
        }}
      >
        Location
      </span>
      <select
        data-phi
        value={current.practiceId}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Select practice"
        style={{
          width: '100%',
          padding: '8px 10px',
          fontSize: '0.9rem',
          color: '#1a1d1b',
          backgroundColor: '#f7f8f7',
          border: '1px solid #e3e7e4',
          borderRadius: '6px',
          cursor: 'pointer',
        }}
      >
        {practices.map((p) => (
          <option key={p.practiceId} value={p.practiceId}>
            {practiceDisplayName(p)}
          </option>
        ))}
      </select>
    </label>
  );
};

export default PracticePicker;
